<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in" v-if="!!allocations">
      <v-flex>
        <v-card>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <!-- <multi-allocation-actions :page="page">
              </multi-allocation-actions>-->
              <!-- <div v-if="userAuthClass">
                                <v-btn :color="$store.state.global.pages.allocation.color" flat @click="matchConfirmDialog = true">Match / Close Allocations</v-btn>
              </div>-->
              <actions
                v-if="userAuthClass || $store.state.user.userAuthClass.allocationRead"
                :selectedCount="selectedCount"
                :selected="selected"
                :selectedAll="selectedAll"
                :pagination="pagination"
              ></actions>
              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">
                <v-tooltip bottom v-if="selected.length > 0 && !selectedAll">
                  <v-btn
                    flat
                    color="grey"
                    icon
                    @click="selected = []; selectedAll = false"
                    slot="activator"
                  >
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>
                <v-menu
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>
              <!-- SELECT ALL ALLOCATIONS ALERT -->
              <v-alert
                v-if="selectedCount >= 10"
                :value="true"
                color="grey lighten-3"
                icon="notification_important"
                style="width: 100%; border-radius: 4px;"
                class="grey--text text--darken-2 py-1"
              >
                <div class="flex-container-center">
                  <span>{{selectedCount}} items are selected.</span>
                  <v-btn
                    v-if="selectedAll"
                    @click="selected = []; selectedAll = false;"
                    flat
                    color="grey"
                  >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selectedCount} items` : ''}}</v-btn>
                  <v-btn
                    v-else
                    @click="selectedAll = true"
                    flat
                    :color="$store.state.global.pages.allocation.color"
                  >Select all {{$vuetify.breakpoint.smAndUp ? `${pagination.totalItems} items` : ''}}</v-btn>
                </div>
              </v-alert>
            </v-layout>
          </v-container>

          <v-data-table
            :items="allocations"
            :headers="headers"
            :pagination.sync="pagination"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :total-items="pagination.totalItems"
            v-model="selected"
            :loading="loading"
            select-all
            disable-initial-sort
          >
            <template slot="items" slot-scope="props">
              <allocation-row
                :allocation="props.item"
                :value="props.selected"
                :headers="headers"
                @input="toggleSelected"
                :key="props.item.id"
                @createDocketFromAllocation="createDocketFromAllocation"
              ></allocation-row>
            </template>
          </v-data-table>

          <!-- DIALOG CONFIRMATION -->
          <!-- <v-dialog v-model="matchConfirmDialog" max-width="700px" @keydown.esc="matchConfirmDialog = false" lazy>       
                        <v-card>
                            <v-card-title class="headline">
                                <layout-no-padding>
                                    <v-flex xs12>
                                        <span>Close any matching allocations?<span class="grey--text subheading"></span></span>
                                    </v-flex>
                                </layout-no-padding>
                                
                            </v-card-title>
                            <v-form @submit.prevent="matchDockets()" >
                                <v-card-actions text-xs-right>
                                <v-btn color="grey darken-1" flat @click="matchConfirmDialog = false">
                                    No
                                </v-btn>
                                <v-btn color="green darken-1" flat type="submit" :loading="loading">
                                    Yes
                                </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
          </v-dialog>-->
        </v-card>
      </v-flex>
    </transition>

    <docket-add-wrapper v-model="addDocketDialog"></docket-add-wrapper>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketAddWrapper from '@/components/addDocket/wrapper'
import AllocationService from '@/services/requests/allocationService'
import AllocationRow from '@/components/allocations/allocationRow'
import AllocationHeaders from '@/components/allocations/allocationHeaders'
import Actions from './allocationActions'
import HeaderFilters from '@/services/mixins/headerFilters'
import BuildAllocationQuery from '@/services/mixins/buildAllocationQuery'
import { debounce } from 'lodash'
export default {
  mixins: [AllocationHeaders, HeaderFilters, BuildAllocationQuery],
  data() {
    return {
      pageOptions: [
        10,
        20,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ],
      color: 'blue',
      searchTerm: '',
      fieldChooserMenu: false,
      addDocketDialog: false,
      // matchConfirmDialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 40, 50]
      },
      selectedAll: false
    }
  },
  methods: {
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object)
      } else {
        var index = this.selected.indexOf(val.object)
        this.selected.splice(index, 1)
      }
    },
    getAllocations(keepPage) {
      //if (!this.billingPeriod) this.billingPeriod = format(new Date(), 'YYYY-MM') //DOESNT WORK
      if (!keepPage) this.pagination.page = 1

      var payload = this.buildQuery()
      payload.pagination = this.pagination
      this.retreiveBatches(payload)
    },
    retreiveBatches(payload) {
      this.loading = true
      AllocationService.getAllocations(payload)
        .then(result => {
          //console.log(res.data);
          this.allocations = result.data.result
          this.pagination.totalItems = result.data.count
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    },
    createDocketFromAllocation(allocation) {
      this.selectedAllocation = allocation
      this.addDocketDialog = true
    }
    // matchDockets() {
    //     this.loading = true;
    //     AllocationService.matchDockets().then(res => {
    //         //console.log(res.data);
    //         // for (var allocation of res.data.result) {
    //         //     this.$store.commit("allocations/updateArrayStateById", {prop: 'allocations', editedValue: allocation})
    //         // }
    //         this.fetchAllocations = true;
    //         this.loading = false;
    //         this.matchConfirmDialog = false;
    //         this.snack({text: res.data.message, color: "green"});
    //     }).catch(err => {
    //         this.snackError();
    //         console.log(err);
    //         this.loading = false;
    //     })
    // },
  },
  computed: {
    allocations: Store.getSet({ store: 'allocations', prop: 'allocations' }),
    loading: Store.getSet({ store: 'allocations', prop: 'loading' }),
    filterBy: Store.getSet({ store: 'allocations', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'allocations', prop: 'filterCol' }),
    filterDate: Store.getSet({ store: 'allocations', prop: 'filterDate' }),
    showVoid: Store.getSet({ store: 'allocations', prop: 'showVoid' }),
    selected: Store.getSet({ store: 'allocations', prop: 'selected' }),
    selectedAllocation: Store.getSet({
      store: 'dockets',
      prop: 'selectedAllocation'
    }),
    //billingPeriod: Store.getSet({store: 'shared', prop: 'billingPeriod'}),
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    fetchAllocations: Store.getSet({
      store: 'allocations',
      prop: 'fetchAllocations'
    }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems
      } else {
        return this.selected.length
      }
    },
    reportsPage() {
      if (this.$route.name == 'showReport') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    if (!this.reportsPage) this.getAllocations()
  },
  beforeDestroy() {
    this.allocations = []
  },
  components: {
    AllocationRow,
    DocketAddWrapper,
    Actions
  },
  watch: {
    // billingPeriod(val) {
    //     this.getAllocations()
    // },
    showVoid(val) {
      this.getAllocations()
    },
    showClosed(val) {
      this.getAllocations()
    },
    projectId(val) {
      this.getAllocations()
    },
    siteId(val) {
      this.getAllocations()
    },
    selectedUserId(val) {
      this.getAllocations()
    },
    pagination(val) {
      this.getAllocations(true)
      //this.$store.commit('trips/setState', {prop: 'pagination', value: val})
    },
    filterCol: debounce(function() {
      this.getAllocations()
    }, 200),
    filterDate: debounce(function() {
      this.getAllocations()
    }, 200),
    filterBy: debounce(function() {
      this.getAllocations()
    }, 500),
    dateRangeStart(val) {
      this.getAllocations()
    },
    dateRangeEnd(val) {
      this.getAllocations()
    },
    fetchAllocations(val) {
      if (val) {
        this.fetchAllocations = false
        this.getAllocations(true)
      }
    }
  }
}
</script>

<style>
</style>